import { render, staticRenderFns } from "./WpsDialog.vue?vue&type=template&id=6a44b832&"
import script from "./WpsDialog.vue?vue&type=script&lang=js&"
export * from "./WpsDialog.vue?vue&type=script&lang=js&"
import style0 from "./WpsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports